import React, { useEffect } from "react";
import styled from "styled-components";
import Footer from "./Footer";

const Parallax = styled.div`
  background-image: url("/images/parallax.jpg");
  background-attachment: fixed;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  padding-top: 10px;
`;

const SquareBox = styled.div`
  background-color: rgba(255, 255, 255, 0.66);
  margin: clamp(5px, 5vw, 10px);
  padding: clamp(15px, 5vw, 100px);
`;

const Title = styled.h1`
  color: #0360ffa2;
  text-align: center;
  font-family: 'MedievalSharp', serif;
  font-size: clamp(1.5rem, 5vw, 2.8rem);
  padding-bottom: clamp(15px, 3vw, 25px);
`;

const Paragraph = styled.p`
  color: #2b60bdff;
  font-family: 'Mozilla Text', serif;
  font-size: clamp(1rem, 2vw, 1.5rem);
  line-height: 1.6;
`;

const PrivacyPolicy = () => {
  useEffect(() => {
    document.title = "Privacy Policy - Anna Miki";
  }, []);

  return (
    <Parallax>

      <SquareBox>

        <Title>Privacy Policy</Title>

        <Paragraph>
          <strong>Last updated:</strong> 13 Dec, 2025
        </Paragraph> <br/>

        <Paragraph>
          This Privacy Policy explains how personal information is collected, used, and
          protected when you visit the website of Anna Miki (“we”, “us”, or “our”).
          We respect your privacy and are committed to handling your personal data in a
          transparent and responsible manner.
        </Paragraph> <br/>

        <Paragraph>
          <strong>1. Information We Collect</strong>
        </Paragraph> <br/>

        <Paragraph>
          We only collect personal information that you voluntarily provide.
        </Paragraph> <br/>

        <Paragraph>
          <strong>Newsletter Subscription</strong><br />
          When you subscribe to the newsletter, we collect your email address.
          Newsletter subscriptions are managed through Mailjet, our email service provider.
        </Paragraph> <br/>

        <Paragraph>
          <strong>Contact Form</strong><br />
          When you contact us via the website, we collect your name, email address,
          and any information you choose to include in your message.
        </Paragraph> <br/>

        <Paragraph>
          <strong>2. How We Use Your Information</strong>
        </Paragraph> <br/>

        <Paragraph>
          Your personal data is used solely to send newsletters (if you subscribe),
          respond to messages submitted through the contact form, and communicate
          information related to Anna Miki’s work.
          We do not sell, rent, or share your personal information for marketing or
          advertising purposes.
        </Paragraph> <br/>

        <Paragraph>
          <strong>3. Email Communications &amp; Mailjet</strong>
        </Paragraph> <br/>

        <Paragraph>
          We use Mailjet to manage newsletter subscriptions and email communications.
          Mailjet stores and processes your email address on our behalf in accordance
          with applicable data protection laws.
          You can unsubscribe from the newsletter at any time using the unsubscribe
          link included in every email.
        </Paragraph> <br/>

        <Paragraph>
          Mailjet’s privacy policy is available at:
          https://www.mailjet.com/legal/privacy-policy/
        </Paragraph> <br/>

        <Paragraph>
          <strong>4. Legal Basis for Processing</strong>
        </Paragraph> <br/>

        <Paragraph>
          If you are located in the European Economic Area (EEA), we process your
          personal data based on your consent when you subscribe to the newsletter
          or submit the contact form, and our legitimate interest in responding to
          inquiries you send us.
        </Paragraph> <br/>

        <Paragraph>
          <strong>5. Data Retention</strong>
        </Paragraph> <br/>

        <Paragraph>
          Newsletter email addresses are retained until you unsubscribe.
          Contact form messages are kept only as long as necessary to respond and
          for reasonable record-keeping.
        </Paragraph> <br/>

        <Paragraph>
          <strong>6. Cookies</strong>
        </Paragraph> <br/>

        <Paragraph>
          This website does not use cookies for analytics, advertising, or tracking
          purposes. Our hosting and infrastructure providers may use strictly
          necessary cookies to ensure the website functions correctly and securely.
          These cookies do not collect personal data and do not track users across websites.
        </Paragraph> <br/>

        <Paragraph>
          <strong>7. Your Rights</strong>
        </Paragraph> <br/>

        <Paragraph>
          Depending on your location, you may have the right to access, correct, or
          delete your personal data, withdraw consent, or object to certain processing.
          To exercise these rights, please contact us using the information below.
        </Paragraph> <br/>

        <Paragraph>
          <strong>8. Data Security</strong>
        </Paragraph> <br/>

        <Paragraph>
          We take reasonable technical and organizational measures to protect your
          personal information. However, no method of transmission over the internet
          is completely secure.
        </Paragraph> <br/>

        <Paragraph>
          <strong>9. Third-Party Links</strong>
        </Paragraph> <br/>

        <Paragraph>
          This website may include links to third-party websites, such as book retailers.
          We are not responsible for the privacy practices or content of those websites.
        </Paragraph> <br/>

        <Paragraph>
          <strong>10. Contact Information</strong>
        </Paragraph> <br/>

        <Paragraph>
          If you have any questions about this Privacy Policy or how your personal data
          is handled, please contact:
          <br />
          <strong>Email:</strong> contact@annamiki.com
        </Paragraph> <br/>

        <Paragraph>
          <strong>11. Changes to This Policy</strong>
        </Paragraph> <br/>

        <Paragraph>
          We may update this Privacy Policy from time to time. Any changes will be posted
          on this page with an updated revision date.
        </Paragraph>

      </SquareBox>

      <Footer />
 
    </Parallax>
  );
};

export default PrivacyPolicy;
